import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountriesCodesService {
  constructor(private http: HttpClient) { }
  loadCountries(): Observable<any> {
    return this.http.get('/assets/countries.json');
  }
}
